<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Clone Campaign</modal-header>
        </div>
      <div class="form-group">
        <div class="field">
          <form-group>
            <field name="Clone Campaign Name" v-model="cloneCampaignName" :error="error"/>
          </form-group>
        </div>
      </div>
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="No, go back" confirmText="Yes"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {campaignMixin} from '@/mixins/campaignMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'

export default {
  name: 'modal_clone_campaign',
  mixins: [modalMixin, campaignMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field
  },
  props: {
    show: Boolean,
    campaignId: String,
    callback: { type: Function, default: null }
  },
  data: () => ({
    cloneCampaignName: '',
    error: ''
  }),
  mounted () {},
  computed: {},
  methods: {
    confirm () {
      if (!this.cloneCampaignName) {
        this.error = 'This value should not be blank.'
        return
      }
      this.startLoading()
      this.cloneCampaign({campaignId: this.campaignId, cloneCampaignName: this.cloneCampaignName}).then((response) => {
        this.addNotification('success', response.reason)
        if (this.callback) this.callback(response.data.hashid)
        this.finishLoading()
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/campaigns/modal-clone-campaign.vue